import { render } from "./FreeText.vue?vue&type=template&id=4e402b80&scoped=true"
import script from "./FreeText.vue?vue&type=script&lang=js"
export * from "./FreeText.vue?vue&type=script&lang=js"

import "./FreeText.vue?vue&type=style&index=0&id=4e402b80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e402b80"]])

export default __exports__